<script lang="ts">
    import Gutter from '$components/layout/gutter.svelte';
    import Text from '$components/common/text/text.svelte';
    import { theme } from '$theme/theme.svelte';

    export let title: string;
    export let subtitle: string | undefined = undefined;
</script>

<header class="header" {...$$restProps}>
    <Gutter class="container">
        <Text
            bold
            center
            variant={$theme.smUp ? 'displayLarge' : 'headlineLarge'}
            class="title"
            color={$theme.colors.white}
        >
            {title}
        </Text>
        <Text
            center
            variant={$theme.smUp ? 'bodyXLarge' : 'bodyLarge'}
            class="subtitle"
            color={$theme.colors.white}
        >
            {@html subtitle}
        </Text>
    </Gutter>
    <slot />
</header>

<style>
    .header {
        /*background-image: linear-gradient(180deg, #022E79 56.71%, #1b2e50 100%);*/
        background-color: var(--colors-primary-800);
        background-image: url('/images/multipage/page-header-background.svg');
        background-position: center;
        background-size: cover;
    }

    .header :global(.container) {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: var(--height-top-bar-desktop);
    }

    .header :global(.title) {
        margin-top: var(--spacing-20);
        margin-bottom: var(--spacing-04);
    }

    @media (min-width: 769px) {
        .header :global(.title) {
            margin-bottom: var(--spacing-08);
            margin-top: 82px;
        }
    }

    .header :global(.subtitle) {
        padding-bottom: var(--spacing-40);
    }

    @media (min-width: 769px) {
        .header :global(.subtitle) {
            padding-bottom: 0px;
            margin-bottom: 82px;
        }
    }
</style>
